export default class VideoPlayerYoutube {
  static playerLibraryRequested = false;

  static playerLibraryLoaded = false;

  static YTPlayerReadyCallbacks = [];

  constructor(src, container) {
    this.rawSrc = src;
    this.container = container;

    this.loadPlayerLibrary().then(this.loadVideo.bind(this));
  }

  // Injects and loads YTPlayer library
  loadPlayerLibrary() {
    return new Promise((resolve) => {
      const proto = Object.getPrototypeOf(this);
      const thisClass = proto.constructor;

      if (thisClass.playerLibraryLoaded) {
        return resolve();
      }

      thisClass.YTPlayerReadyCallbacks.push(resolve);

      if (!this.playerLibraryRequested) {
        this.playerLibraryRequested = true;
        window.onYouTubeIframeAPIReady =
          thisClass.onYouTubeIframeAPIReady.bind(thisClass);

        // Inject library
        const tag = document.createElement("script");
        tag.src = "https://www.youtube.com/iframe_api";
        const firstScriptTag = document.getElementsByTagName("script")[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
      }
    });
  }

  loadVideo() {
    this.youtubeID = this.extractIdFromURL(this.rawSrc);

    if (this.youtubeID) {
      this.renderPlayer();
      this.checkPoster();
    }
  }

  extractIdFromURL(rawVideoURL = "") {
    const match = rawVideoURL.match(
      /.*(?:youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=)([^#&?]*).*/
    );
    return match && match[1] ? match[1] : null;
  }

  renderPlayer() {
    const playerContainer = document.createElement("div");

    // Append to DOM
    this.container.insertAdjacentElement("afterbegin", playerContainer);

    this.rawPlayer = new window.YT.Player(playerContainer, {
      width: this.container.offsetWidth,
      height: this.container.offsetWidth * (9 / 16),
      videoId: this.youtubeID,
    });
  }

  // Checks if a poster exists. Generate one if there isn't
  checkPoster() {
    if (!this.container.nextElementSibling.firstElementChild) {
      const urls = this.generateThumbnailURLs();
      const picture = Object.assign(document.createElement("picture"), {
        className: "responsive-image",
      });

      picture.innerHTML = `
        <source media="(max-width: 767px)" srcset="${urls.mobile}">
        <source media="(max-width: 1199px)" srcset="${urls.tablet}">
        <source media="(min-width: 1200px)" srcset="${urls.desktop}">
        <img src="${urls.mobile}">
      `;

      this.container.nextElementSibling.innerHTML = picture.outerHTML;
    }
  }

  generateThumbnailURLs() {
    return {
      mobile: `https://img.youtube.com/vi/${this.youtubeID}/sddefault.jpg`,
      tablet: `https://img.youtube.com/vi/${this.youtubeID}/mqdefault.jpg`,
      desktop: `https://img.youtube.com/vi/${this.youtubeID}/hqdefault.jpg`,
    };
  }

  play() {
    this.rawPlayer.playVideo();
  }

  static onYouTubeIframeAPIReady() {
    this.YTPlayerReadyCallbacks.forEach((callback) => callback());

    this.playerLibraryLoaded = true;
  }
}
